import { PRICES } from "@/content";

export const Prices = () => (
  <section className="prices" id="valores" data-testid="prices-section">
    <div className="wrap">
      <div className="section-head">
        <p className="eyebrow">{PRICES.eyebrow}</p>
        <h2>{PRICES.title}</h2>
        <p>{PRICES.intro}</p>
      </div>
      <div className="price-grid">
        {PRICES.sessions.map((session) => (
          <article
            key={session.title}
            className={session.featured ? "price-card featured" : "price-card"}
            data-testid={`price-card-${session.title}`}
          >
            <h3>{session.title}</h3>
            <p className="price-meta">{session.meta}</p>
            <p>{session.text}</p>
            <a
              className="text-link"
              href={session.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`price-link-${session.title}`}
            >
              {PRICES.actionLabel}
            </a>
          </article>
        ))}
      </div>
      <h3 className="packages-title">{PRICES.packagesTitle}</h3>
      <p>{PRICES.packagesIntro}</p>
      <div className="package-grid">
        {PRICES.packages.map((pack) => (
          <article className="package" key={pack.title} data-testid={`package-${pack.title}`}>
            <p className="eyebrow">{pack.sessionsLabel}</p>
            <h3>{pack.title}</h3>
            <p>
              De <s>{pack.oldPrice}</s>
            </p>
            <p className="package-price">{pack.price}</p>
            <p>{pack.perSession}</p>
            <a
              className="text-link"
              href={pack.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`package-link-${pack.title}`}
            >
              {PRICES.packageActionLabel}
            </a>
          </article>
        ))}
      </div>
      <p className="price-note">{PRICES.note}</p>
      <a className="next-link" href={PRICES.nextLink.href} data-testid="prices-next-link">
        {PRICES.nextLink.label}
      </a>
    </div>
  </section>
);
